module.exports = __webpack_public_path__ + "static/photo_12-49945db77c15b76d089786ac1598135b.jpg";